module.exports = __webpack_public_path__ + "img/ico-del-user.ce7ba6ab.svg";